import axios from 'axios';

export default function queryProducts({
  manufacturer,
  type,
  size,
  detail,
  locale
}) {
  const qParamsData = {};
  qParamsData.manufacturer = manufacturer;
  qParamsData.facetType = type;
  qParamsData.facetSize = size;
  qParamsData.facetDetails = detail;
  qParamsData.locale = locale;

  return axios.post(
    `${process.env.REACT_APP_BACKEND_BASE_URL}/api/products/search`,
    qParamsData
  );
}



// WEBPACK FOOTER //
// ./src/utils/queryProducts.js